/**
 * Numeric shape constants for the library preview frame (`LibraryPreviewFrame`), carried
 * over verbatim from the prototype library kit (`git show c95995d9:src/common/presentation/
 * components/library/LibraryPreviewFrame.tsx`) so later Parts that layer richer fit-to-content
 * zoom back in can reuse the same measurements rather than re-deriving them. See
 * `LibraryPreviewFrame.tsx`'s own doc comment. Hover-open is the card's `hoverExpand`
 * mode; per-item auto-zoom measurement is still not ported.
 */

/** A4 portrait, the sheet every block and template renders on: 210 x 297mm. */
export const A4_ASPECT = 297 / 210;

/** The crop window's shape — a wide letterbox, 326 x 119 in the source Figma mock (483:249). */
export const LIBRARY_PREVIEW_CROP_ASPECT = 326 / 119;

/** The document renderer's reference sheet width (px) the preview scales against. */
export const LIBRARY_PREVIEW_PAPER_WIDTH_PX = 768;

/**
 * Width the live document is laid out at before the crop scales it.
 * Wider than an A4 page (793px) plus the document frame's horizontal padding, so
 * `DocumentRender`'s own fit-scale stays at 1. That inner scale uses
 * `transform-origin: center top` inside a narrow host and slides the page out of
 * this frame's overflow crop — the Add-panel preview flashes, then the well is empty.
 */
export const LIBRARY_PREVIEW_LAYOUT_WIDTH_PX = 960;

/** How much of a template's first page its preview shows — top-aligned, fit-to-width. */
export const LIBRARY_TEMPLATE_PAGE_FRACTION = 0.5;

/** How much of the tallest seeded block's page height a block preview is measured to contain. */
export const LIBRARY_BLOCK_PAGE_FRACTION = 0.3;

/**
 * A block card's preview box shape — 4:3, the smallest box that holds the tallest seeded
 * block (Roles & responsibilities, ~53% of an A4 page) without scaling it below fit-to-width.
 */
export const LIBRARY_BLOCK_BOX_ASPECT = 4 / 3;

/** Inset (px) between the preview well's edge and the document sheet inside it. */
export const LIBRARY_PREVIEW_SHEET_INSET_PX = 8;

/** Canvas fill behind the sheet — matches the block/template editor's own canvas colour. */
export const LIBRARY_PREVIEW_CANVAS_BG = 'var(--surface-neutral-container-tertiary)';
